// =============================================================================
// BACKUP PAGES LAYOUTS
// =============================================================================

export default {
  path: 'backup',
  name: 'backup',
  component: () => import(/* webpackChunkName: "backup" */ '../../views/admin/settings/backup/backup.vue'),
  meta: {
    pageTitle: '',
    pageTitleI18n: 'backup.title'
    // rule: 'editor'
  }
}
